import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { DistribuicaoSaldoComponent } from "./pages/distribuicao-saldo/distribuicao-saldo.component";
import { HistoricoImportacaoFuncionarioComponent } from "./pages/historico-importacao-funcionario/historico-importacao-funcionario.component";
import { ImportacaoFinalizadaComponent } from "./pages/importacao-finalizada/importacao-finalizada.component";
import { ValidarImportacaoComponent } from "./pages/validar-importacao/validar-importacao.component";
import { ValidarPagamentoCartaoComponent } from "./pages/validar-pagamento-cartao/validar-pagamento-cartao.component";
import { ImportacaoLoteComponentsModule } from "../../shared/importacao-lote/importacao-lote.module";
import { NgxMyDatePickerModule } from "ngx-mydatepicker";
import { CommonModule } from "@angular/common";
import { ImportarArquivoFuncionarioLoteComponent } from "./pages/importar-arquivo-funcionario-lote/importar-arquivo-funcionario-lote.component";
import { ComponentstModule } from "../components/components.module";

@NgModule({
  imports: [
    CommonModule,
    ComponentstModule,
    NgxMyDatePickerModule.forRoot(),
    ImportacaoLoteComponentsModule,
  ],
  declarations: [
    DistribuicaoSaldoComponent,
    HistoricoImportacaoFuncionarioComponent,
    ImportarArquivoFuncionarioLoteComponent,
    ValidarImportacaoComponent,
    ValidarPagamentoCartaoComponent,
    ImportacaoFinalizadaComponent,
  ],
  exports: [
    DistribuicaoSaldoComponent,
    HistoricoImportacaoFuncionarioComponent,
    ImportarArquivoFuncionarioLoteComponent,
    ValidarImportacaoComponent,
    ValidarPagamentoCartaoComponent,
    ImportacaoFinalizadaComponent,
  ],
  // entryComponents: [DistribuicaoSaldoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ImportacaoFuncionarioLoteModule {}
